<template>
  <div class="edit_cost_dialog">
    <custom-dialog :visible="visible" width="1200px" :title="model.title" v-on="$listeners">
      <div class="dialog-body">
        <div class="title">{{ $t('crm_edit_cost_dialog.ye_wu_xin_xi') }}</div>
        <div class="item-title-info">
          <el-row>
            <el-col :span="6">
              <span class="label">{{ $t('crm_edit_cost_dialog.ding_dan_hao') }}:</span>
              <span class="value">{{  model.data.orderGoodsCode || '-' }}</span>
            </el-col>
            <el-col :span="6">
              <span class="label">{{ $t('crm_edit_cost_dialog.chan_pin_xing_hao') }}:</span>
              <span class="value">{{ model.data.productCode || '-' }}</span>
            </el-col>
            <el-col :span="6">
              <span class="label">{{ $t('crm_edit_cost_dialog.ji_shen_hao') }}:</span>
              <span class="value">{{  model.data.bodyNum || '-'}}</span>
            </el-col>
            <el-col :span="6">
              <span class="label">{{ $t('crm_edit_cost_dialog.shou_hou_gong_si') }}:</span>
              <span class="value">{{ model.data.afterServiceName || '-' }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="title">{{ $t('crm_edit_cost_dialog.pei_jian_xin_xi') }}</div>
        <div class="table-dialog-bd">
          <custom-table :tableCode="tableCode" height="500px" :data="tableList" :index="true" :slots="['partSn','costPrice']">
            <template v-slot:partSn="scope">
              <span>
                {{ scope.row.goodsCode || '-'}}/{{ scope.row.goodsName|| '-'}}
              </span>
            </template>
            <template  v-slot:costPrice="scope">
              <el-input type="number" :min="0" style="width:100%;" v-model="scope.row.costPrice"></el-input>
            </template>
          </custom-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveItem">{{ $t('Common.com_save') }}</el-button>
        <el-button size="small" type="primary" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';


export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'accessory_part',
      info: {},
      // 获取row的key值

      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        bodyNum: '',
        workOrderId: '',
      },
      beforeFileList: [],
      afterFileList: [],
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted() {
    this.initDialog();
    this.getTableColumn();

  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });

      this.getTableList();

    },
    // 获取表格数据列表
    getTableList: function () {
      const orderGiveawayId = this.model.data.orderGiveawayId;
      this.$getJSON(`${apis.giveawayCostsharePartList}/${orderGiveawayId}`).then((res) => {
        this.tableList = res.data;
      });
    },
    // 保存
    saveItem: function () {
      // 表单验证
      const hasEmpty = this.tableList.find(
        t => t.costPrice === ''
      );
      if (hasEmpty) {
        this.$message.error(this.$t('crm_edit_cost_dialog.qtxcbdj'));
        return;
      }
      const sumProfit = this.tableList.find(
        t => +t.costPrice < 0
      );
      if (sumProfit) {
        this.$message.error(this.$t('crm_edit_cost_dialog.cbdjbnxy0'));
        return;
      }

      // this.tableList.forEach(i => i.agentCoProfit = (i.unitPrice - i.hqProfit - i.afterServiceProfit).toFixed(2));
      const partList = this.tableList.map(item => ({
        costPrice: item.costPrice,
        orderGiveawayId: item.orderGiveawayId,
        orderGoodsCode: item.orderGoodsCode,
        orderGoodsPartId: item.orderGoodsPartId,
        orderPartId: item.orderPartId,
      }));
      this.$postJSON(apis.giveawayCostsharePartEditCost, partList).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },


  },
};
</script>

<style lang="scss">
.edit_cost_dialog {
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 22px;
    font-size: 14px;
    margin-bottom: 16px;
    position: relative;
    padding-left: 10px;
    &:after {
      content: '';
      position: absolute;
      width: 4px;
      height: 15px;
      background: rgba(0, 175, 255, 1);
      left: 0px;
      top: 4px;
    }
  }
  .part-pic {
    padding: 16px;
    h1 {
      font-weight: bold;
      line-height: 17px;
      margin-bottom: 10px;

      font-size: 12px;
      color: #495057;
      line-height: 17px;
    }
    ul li img {
      width: 60px;
      height: 60px;
      border-radius: 2px;
      // border: 1px solid rgba(238, 238, 238, 1);
      margin-right: 16px;
    }
  }
}
</style>
